import React, { useState, useEffect } from "react";
import { FaSpinner } from "react-icons/fa";
import ReactDatePicker from "react-datepicker";
import { Table } from "react-bootstrap";
import moment from "moment";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import LeaveSummary from "./LeaveSummary";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { getDay } from "date-fns";
import LeaveHistory from "./LeaveHistory";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { FileUploader } from "./components/MultipleFileUploader";
import EditWfhModal from "./EditWfhModal";
import RequestCategoryToggle from "../../../../components/RequestCategoryToggle";

const ApplyLeave = () => {
  const navigate = useNavigate();

  let today = moment().format("DD-MMM-YYYY");
  const initialFormData = {
    FromDate: moment(new Date()).format("DD-MMM-YYYY"),
    ToDate: moment(new Date()).format("DD-MMM-YYYY"),
    EmployeeID: "", // Empty string (or default value if needed)
    // dates: "", // Empty until dates are selected
    Purpose: "", // Empty string
    revisionNumber: "",
    leaveID: "", // Empty (or auto-generated later)
    rowstatus: 435, // Empty (or default like "0" if required)
    leavesFile: null, // No file selected initially
  };
  const [leaveDetails, setLeaveDetails] = useState([]);
  console.log("leaveDetails:::", leaveDetails);

  const [pageLoading, setPageLoading] = useState(true);
  const [daysDifference, setDaysDifference] = useState(1);
  const [disabledDatess, setDisabledDatess] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [requestCategory, setRequestCategory] = useState("Leave");
  const [wfhAnomalyDates, setWfhAnomalyDates] = useState([]);
  const [globalWfhType, setGlobalWfhType] = useState("WFH");
  const [wfhPurpose, setWfhPurpose] = useState("");
  const [wfhHistory, setWfhHistory] = useState([]);
  const [wfhAppliedDates, setWfhAppliedDates] = useState([]);
  const [presentDates, setPresentDates] = useState([]);
  const [payrollCalculatedEndDate, setPayrollCalculatedEndDate] = useState(null);
  const [joiningDate, setJoiningDate] = useState(null);
  const [relivingDate, setRelivingDate] = useState(null);
  const [wfhRows, setWfhRows] = useState({});
  const [showWfhModal, setShowWfhModal] = useState(false);
  const [selectedWfhGroup, setSelectedWfhGroup] = useState(null);
  const [wfhFromDate, setWfhFromDate] = useState(null);
  const [wfhToDate, setWfhToDate] = useState(null);
  const [wfhExcludedDates, setWfhExcludedDates] = useState([]);
  const [displayedDates, setDisplayedDates] = useState([
    moment().format("DD-MMM-YYYY"),
  ]);
  const [errors, setErrors] = useState({});
  const [leaveoptions, setLeaveOptions] = useState([]);
  const [leaveHistory, setLeaveHistory] = useState([]);
  const [lineData, setLineData] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Apply Leave"));
    fetchLeaveDetails();
    fetchMissingPunches();
    setFileUrl(null);
    setFile(null);
    setFileName("");
    setFormData(initialFormData);
  }, []);

  const [empDetails, SetEmpDetails] = useState([]);
  
  const fetchMissingPunches = async () => {
    try {
      const response = await GetServiceCaller(API_URL+"work-requests");
      if (response && response.status === 200 && response.data && response.data.status === "success") {
         let dates = [];
         let history = [];
         response.data.data.forEach(req => {
            if (req.is_anomaly && req.anomaly_dates) {
                req.anomaly_dates.forEach(d => {
                    dates.push(moment(d).format("DD-MMM-YYYY"));
                });
            } else if (!req.is_anomaly) {
                const hasValid = req.grouped_requests 
                    ? req.grouped_requests.some(r => r.request_type !== "Cancel")
                    : req.request_type !== "Cancel";
                if (hasValid) {
                    history.push(req);
                }
            }
         });
         const uniqueDates = [...new Set(dates)];
         setWfhAnomalyDates(uniqueDates);
         setWfhHistory(history);
         const isInactive = (item) =>
            !item ||
            [827, 1132].includes(Number(item.status)) ||
            ["Rejected", "Cancelled", "Revoked"].includes(item.status_name) ||
            item.request_type === "Cancel";

         let appliedDates = [];
         history.forEach(req => {
            if (isInactive(req)) return;

            const list = req.grouped_requests?.length ? req.grouped_requests : [req];
            list.forEach(r => {
               if (!isInactive(r) && (r.date || r.from_date)) {
                  appliedDates.push(moment(r.date || r.from_date).format("DD-MMM-YYYY"));
               }
            });
         });
         setWfhAppliedDates([...new Set(appliedDates)]);
           if (response.data.present_dates) {
             const pDates = response.data.present_dates.map(d => moment(d, 'DD-MMM-YYYY').format('DD-MMM-YYYY'));
             setPresentDates(pDates);
           }
           if (response.data.payrollCalculatedEndDate) {
            setPayrollCalculatedEndDate(response.data.payrollCalculatedEndDate);
          }
         const initialRows = {};
         uniqueDates.forEach(d => {
             initialRows[d] = { type: '', reason: '' };
         });
         setWfhRows(initialRows);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLeaveDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}apply-leave`);

      if (response?.status === 200) {
        const empDetails = response?.data?.data[0];
        SetEmpDetails(empDetails);
        setFormData((prevData) => ({
          ...prevData,
          EmployeeID: empDetails?.DefaultContactID,
          revisionNumber: empDetails?.RevisionNumber ?? 0, // Updating revisionNumber
        }));
        const data = response?.data?.leaveSummary;
        const leaveHistory = response?.data?.leaveHistory;
        const leaveDisabled = response?.data?.datesdisabled;

        setLeaveHistory(leaveHistory);
        setLeaveDetails(data);

        // Convert leaveDisabled dates into Date objects
        const parsedHolidays = leaveDisabled ? leaveDisabled.map(
          (dateStr) => moment(dateStr, "YYYY-MM-DD").toDate() // Convert the holiday date to a Date object
        ) : [];
        setDisabledDatess(parsedHolidays);

        if (response?.data?.payrollCalculatedEndDate) {
          setPayrollCalculatedEndDate(response.data.payrollCalculatedEndDate);
        }

        // Filter out the unwanted LeaveID and LeaveType
        const filteredData = data.filter(
          (comp) => !(comp.LeaveID === 3 && comp.LeaveType === "Total")
        );
        const leaveopt = filteredData.map((comp) => ({
          value: comp.LeaveID,
          label: comp.LeaveType,
        }));
        setLeaveOptions(leaveopt);
        setPageLoading(false);
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const filteredLeaveDetails = leaveDetails.filter((item) =>
    ["C-Off", "EL", "LOP", "Total"].includes(item.LeaveType)
  );
  console.log("filteredLeaveDetails", filteredLeaveDetails);

  const countWeekdays = (startDate, endDate) => {
    let count = 0;
    let currentDate = moment(startDate);

    while (currentDate.isSameOrBefore(endDate, "day")) {
      if (isWeekday(currentDate.toDate())) {
        count++;
      }
      currentDate.add(1, "days");
    }
    return count;
  };

  const handleDateChange = (date, field) => {
    const formattedDate = moment(date).format("DD-MMM-YYYY");

    if (field === "FromDate") {
      setFormData({
        ...formData,
        FromDate: formattedDate,
        ToDate: formattedDate, // Reset ToDate to FromDate to avoid invalid ranges
      });

      const daysDiff = countWeekdays(formattedDate, formattedDate);
      setDaysDifference(daysDiff);
      setDisplayedDates(generateDateRange(formattedDate, formattedDate));
    } else if (field === "ToDate") {
      const fromDateMoment = moment(formData.FromDate, "DD-MMM-YYYY");
      const toDateMoment = moment(formattedDate, "DD-MMM-YYYY");

      if (toDateMoment.isBefore(fromDateMoment, "day")) {
        toast.error("To Date cannot be before From Date!");
        return;
      }

      setFormData({ ...formData, [field]: formattedDate });

      const daysDiff = countWeekdays(fromDateMoment, toDateMoment);
      setDaysDifference(daysDiff);
      setDisplayedDates(generateDateRange(formData.FromDate, formattedDate));
    }
  };

  const generateDateRange = (fromDate, toDate) => {
    let currentDate = moment(fromDate, "DD-MMM-YYYY");
    const endDate = moment(toDate, "DD-MMM-YYYY");
    let dates = [];

    while (currentDate.isSameOrBefore(endDate, "day")) {
      if (isWeekday(currentDate.toDate())) {
        dates.push(currentDate.format("DD-MMM-YYYY"));
      }
      currentDate.add(1, "days");
    }

    // Store filtered dates as comma-separated string in newDates state
    // setNewDates(dates.join(', '));
    return dates;
  };

  const isAlreadyAppliedLeave = (date) => {
    if (!leaveHistory || leaveHistory.length === 0) return false;
    const dateToCheck = moment(date).startOf('day');
    return leaveHistory.some((req) => {
      if (req.ApplicationStatus === "Rejected" || req.ApplicationStatus === "Cancelled" || req.ApplicationStatus === "Revoked") return false;
      if (!req.FromDate || !req.ToDate) return false;
      const fromDate = moment(req.FromDate, "YYYY-MM-DD").startOf('day');
      const toDate = moment(req.ToDate, "YYYY-MM-DD").startOf('day');
      return dateToCheck.isBetween(fromDate, toDate, 'day', '[]');
    });
  };

  const isWeekday = (date) => {
    const day = moment(date).isoWeekday(); // 6 = Saturday, 7 = Sunday

    const today = moment();
    const firstDayOfCurrentMonth = today.startOf("month");
    const lastDayOfPrevMonth = firstDayOfCurrentMonth
      .clone()
      .subtract(1, "day");
    const firstDayOfPrevMonth = lastDayOfPrevMonth.clone().startOf("month");

    // disabledDatess contains both weekly offs and holidays specific to the employee's shift
    const isHolidayOrWeekOff = disabledDatess.some((disabledDate) =>
      moment(disabledDate).isSame(moment(date), "day")
    );

    let isMarkedDate = false;
    if (requestCategory === "WFH/BT") {
      const dateToCheck = moment(date).startOf('day');
      const dateStr = dateToCheck.format("DD-MMM-YYYY");
      
      // Disable if WFH/BT is already applied for this date
      if (wfhAppliedDates.includes(dateStr)) {
        isMarkedDate = true;
      }
      
      // Disable if present in biometric
      if (presentDates.includes(dateStr)) {
        isMarkedDate = true;
      }
    } else {
      // Logic for regular Leave
      if (isAlreadyAppliedLeave(date)) {
        isMarkedDate = true;
      }
    }
    return !isHolidayOrWeekOff && !isMarkedDate;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });

    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.Purpose?.trim()) {
      newErrors.Purpose = "Purpose is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
      if (requestCategory === "WFH/BT") {
         if (!wfhPurpose || !wfhPurpose.trim()) {
            toast.error("Purpose is required.");
            return;
         }

         const requestsToSubmit = [];
         const displayDates = getWfhDisplayDates();
         let currentGroup = null;

         // The pickers already limit the range, but a date typed in by hand or a range
         // carried over from another month must not slip through.
         const hasOtherMonthDate = displayDates.some(
            (d) => !moment(d, "DD-MMM-YYYY").isSame(moment(), "month")
         );
         if (hasOtherMonthDate) {
            toast.error("WFH/BT can be applied only for the current month.");
            return;
         }

         for (let i = 0; i < displayDates.length; i++) {
            const date = displayDates[i];
            const formattedDate = moment(date, "DD-MMM-YYYY").format("YYYY-MM-DD");
            const rowType = globalWfhType || "WFH";
            const rowReason = wfhPurpose.trim();
            
            if (!currentGroup) {
               currentGroup = {
                  request_type: rowType,
                  from_date: formattedDate,
                  to_date: formattedDate,
                  reason: rowReason
               };
            } else {
               const currentDateObj = moment(formattedDate, "YYYY-MM-DD");
               const lastDateObj = moment(currentGroup.to_date, "YYYY-MM-DD");
               const isConsecutive = currentDateObj.diff(lastDateObj, 'days') === 1;

               if (currentGroup.request_type === rowType && isConsecutive) {
                  currentGroup.to_date = formattedDate;
               } else {
                  requestsToSubmit.push(currentGroup);
                  currentGroup = {
                     request_type: rowType,
                     from_date: formattedDate,
                     to_date: formattedDate,
                     reason: rowReason
                  };
               }
            }
         }
         if (currentGroup) {
            requestsToSubmit.push(currentGroup);
         }

       if (requestsToSubmit.length === 0) {
          toast.error("Please fill in at least one missing punch to submit.");
          return;
       }

       setSubmit(true);
       try {
         const payload = {
            requests: requestsToSubmit
         };
         const res = await PostServiceCaller(API_URL+"work-requests", payload, "POST");
         if (res && (res.status === 200 || res.status === 201)) {
            toast.success("WFH/BT request submitted successfully!");
            setWfhPurpose("");
            fetchMissingPunches();
         } else {
            toast.error("Failed to submit request.");
         }
       } catch (err) {
         toast.error("An error occurred during submission");
       } finally {
         setSubmit(false);
       }
       return;
    }

    if (validateForm()) {
      let remainingCOff =
        filteredLeaveDetails.find((leave) => leave.LeaveType === "C-Off")
          ?.LeaveBalance || 0;
      let remainingEL =
        filteredLeaveDetails.find((leave) => leave.LeaveType === "EL")
          ?.LeaveBalance || 0;

      const updatedLeaveApplicationLines = displayedDates.map((date, index) => {
        let leaveType = "LOP";

        if (remainingCOff > 0) {
          leaveType = "C-Off";
          remainingCOff--;
        } else if (remainingEL > 0) {
          leaveType = "EL";
          remainingEL--;
        }

        // Find the corresponding LeaveID for the leaveType
        const leaveOption = leaveoptions.find(
          (option) => option.label === leaveType
        );
        const leaveID = leaveOption ? leaveOption.value : null;

        return {
          LineNo: index + 1,
          Date: date,
          LeaveID: leaveID,
        };
      });

      // Update the form data using functional update to avoid stale closures
      const updatedFormData = {
        ...formData,
        leaveApplicationLines: updatedLeaveApplicationLines,
      };

      setFormData((prevFormData) => updatedFormData);
      setSubmit(true);
      // Determine the HTTP method and URL based on the presence of an ID
      const method = updatedFormData.id ? "put" : "post";
      const url = updatedFormData.id
        ? `${API_URL}apply-leave/${updatedFormData.id}`
        : `${API_URL}apply-leave`;

      // Handle the actual form submission by sending data to the backend API using Axios
      PostFormServiceCaller(
        url,
        {
          ...updatedFormData,
          // dates: newDates
        },
        method
      )
        .then((response) => {
          toast.success("Leave submitted successfully!");
          fetchLeaveDetails();
          setSubmit(false);
          // setTimeout(() => {
          //   window.location.reload();
          // }, 2000);
          setFormData({
            Purpose: "",
            FromDate: today,
            ToDate: today,
            leaveApplicationLines: [],
            leavesFile: null,
          });
          setDisplayedDates([moment().format("DD-MMM-YYYY")]);
        })
        .catch((error) => {
          console.error("Error submitting the form:", error);
          setSubmit(false);
          // Display error message from backend if available
          const errorMessage =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Failed to submit leave application";
          toast.error(errorMessage);
        });
      // Optionally, log the form data to be submitted
    }
  };

  const handleEdit = (idOrGroup) => {
    if (Array.isArray(idOrGroup)) {
      setSelectedWfhGroup(idOrGroup);
      setShowWfhModal(true);
    } else {
      navigate(`/apply-leave/edit/${idOrGroup}`, { state: { disabledDatess } });
    }
  };

  let remainingCOff =
    filteredLeaveDetails.find((leave) => leave.LeaveType === "C-Off")
      ?.LeaveBalance || 0;
  let remainingEL =
    filteredLeaveDetails.find((leave) => leave.LeaveType === "EL")
      ?.LeaveBalance || 0;

  const handleFile = (files) => {
    if (files) {
      const selectedFile = files;

      // Create object URL
      const url = URL.createObjectURL(selectedFile);
      setFileUrl(url); // Store the URL

      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        leavesFile: "",
      }));

      setFile(selectedFile);
      setFileName(selectedFile.name);

      setFormData((prevState) => ({
        ...prevState,
        leavesFile: selectedFile,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        leavesFile:
          "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };

  // Don't forget to revoke the object URL when component unmounts
  useEffect(() => {
    return () => {
      if (fileUrl) {
        URL.revokeObjectURL(fileUrl);
      }
    };
  }, [fileUrl]);

  // WFH/BT can only be applied for the current month; if payroll is already calculated
  // for part of it, the earliest selectable date moves to the day after the payroll end.
  const getWfhMinDate = () => {
    const startOfMonth = moment().startOf("month");
    if (payrollCalculatedEndDate) {
      const afterPayroll = moment(payrollCalculatedEndDate).add(1, "day");
      if (afterPayroll.isAfter(startOfMonth)) return afterPayroll.toDate();
    }
    return startOfMonth.toDate();
  };
  const getWfhMaxDate = () => moment().endOf("month").toDate();

  const getWfhDisplayDates = () => {
    if (!wfhFromDate || !wfhToDate) return [];
    let start = moment(wfhFromDate).clone();
    let end = moment(wfhToDate);
    let dates = [];
    while (start.isSameOrBefore(end, 'day')) {
      const dateStr = start.format("DD-MMM-YYYY");
      if (!wfhAppliedDates.includes(dateStr) && !isAlreadyAppliedLeave(start.toDate()) && !wfhExcludedDates.includes(dateStr)) {
          if (isWeekday(start.toDate())) {
             dates.push(dateStr);
          }
      }
      start.add(1, 'day');
    }
    return dates;
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid">
          <div className="row gx-lg-1">
            <div className="col-12 col-lg-7 pe-1">
              <div className="container-fluid" id="skill-table-area">
                <form className="p-2" onSubmit={handleSubmit}>
                  <div className="row mb-3 align-items-center">
                    <div className="col-auto">
                      <label className="form-label fw-bold d-block">Request Category</label>
                      <RequestCategoryToggle activeTab={requestCategory} setActiveTab={setRequestCategory} />
                    </div>
                    {requestCategory === "WFH/BT" && (
                      <div className="col-auto ms-3 d-flex align-items-center gap-3 pt-3">
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="globalWfhType"
                            id="globalWfh"
                            value="WFH"
                            checked={globalWfhType === "WFH"}
                            onChange={(e) => setGlobalWfhType(e.target.value)}
                          />
                          <label className="form-check-label fw-bold" htmlFor="globalWfh" style={{ cursor: "pointer" }}>
                            WFH
                          </label>
                        </div>
                        <div className="form-check mb-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="globalWfhType"
                            id="globalBt"
                            value="Business Travel"
                            checked={globalWfhType === "Business Travel"}
                            onChange={(e) => setGlobalWfhType(e.target.value)}
                          />
                          <label className="form-check-label fw-bold" htmlFor="globalBt" style={{ cursor: "pointer" }}>
                            Business Travel
                          </label>
                        </div>
                      </div>
                    )}
                  </div>

                  {requestCategory === "WFH/BT" ? (
                    <>
                    <div className="row">
                       <div className="col-sm-4">
                          <label htmlFor="wfhPurpose" className="form-label">
                            Purpose<span className="required">*</span>
                          </label>
                          <textarea
                             className="form-control"
                             id="wfhPurpose"
                             name="wfhPurpose"
                             rows="1"
                             value={wfhPurpose}
                             onChange={(e) => setWfhPurpose(e.target.value)}
                             placeholder="Enter purpose..."
                          />
                       </div>
                       <div className="col-sm-3">
                          <label htmlFor="wfhFromDate" className="form-label">
                            From Date<span className="required">*</span>
                          </label>
                          <ReactDatePicker
                            autoComplete="off"
                            changeYear
                            changeMonth
                            showPopperArrow
                            showIcon
                            icon="fa fa-calendar"
                            className="form-control"
                            format="d-MM-YYYY"
                            name="wfhFromDate"
                            id="wfhFromDate"
                            filterDate={(date) => {
                               const dateStr = moment(date).format("DD-MMM-YYYY");
                               if (wfhAppliedDates.includes(dateStr)) return false;
                               if (isAlreadyAppliedLeave(date)) return false;
                               return isWeekday(date);
                            }}
                            onChange={(date) => setWfhFromDate(date)}
                            selected={wfhFromDate}
                            dateFormat="dd-MMM-yyyy"
                            minDate={getWfhMinDate()}
                            maxDate={getWfhMaxDate()}
                          />
                       </div>
                       <div className="col-sm-3">
                          <label htmlFor="wfhToDate" className="form-label">
                            To Date<span className="required">*</span>
                          </label>
                          <ReactDatePicker
                            autoComplete="off"
                            changeYear
                            changeMonth
                            showPopperArrow
                            showIcon
                            icon="fa fa-calendar"
                            className="form-control"
                            format="d-MM-YYYY"
                            name="wfhToDate"
                            id="wfhToDate"
                            filterDate={(date) => {
                               const dateStr = moment(date).format("DD-MMM-YYYY");
                               if (wfhAppliedDates.includes(dateStr)) return false;
                               if (isAlreadyAppliedLeave(date)) return false;
                               return isWeekday(date);
                            }}
                            onChange={(date) => setWfhToDate(date)}
                            selected={wfhToDate}
                            dateFormat="dd-MMM-yyyy"
                            minDate={getWfhMinDate()}
                            maxDate={getWfhMaxDate()}
                          />
                       </div>
                       <div className="col-sm-2">
                          <label htmlFor="wfhNoOfDays" className="form-label">
                            Total Days
                          </label>
                          <input
                             type="text"
                             className="form-control text-center bg-light fw-bold"
                             id="wfhNoOfDays"
                             readOnly
                             disabled
                             value={getWfhDisplayDates().length}
                          />
                       </div>
                    </div>
                    <div className="row">
                       <div className="col-12 mt-2">
                          <Table bordered style={{ tableLayout: "fixed" }}>
                             <thead className="text-center" id="thcolor">
                                <tr>
                                   <th style={{ width: "20%" }}>Sr. No.</th>
                                   <th style={{ width: "45%" }}>Date</th>
                                   <th style={{ width: "35%" }}>Type</th>
                                </tr>
                             </thead>
                             <tbody>
                               {getWfhDisplayDates().length === 0 ? (
                                  <tr><td colSpan="3" className="text-center">No missing punches found in this date range</td></tr>
                               ) : (
                                  getWfhDisplayDates().map((date, index) => (
                                     <tr key={date}>
                                        <td className="text-center align-middle fw-bold">{index + 1}</td>
                                        <td className="text-center align-middle fw-bold">{date}</td>
                                        <td className="text-center align-middle fw-semibold">{globalWfhType}</td>
                                     </tr>
                                  ))
                               )}
                             </tbody>
                          </Table>
                       </div>
                    </div>
                    </>
                  ) : (
                    <>
                  <div className="row">
                    <div className="col-sm-4">
                      <label for="leave-type" class="form-label">
                        Purpose<span className="required">*</span>
                      </label>
                      <textarea
                        type="text"
                        className={`form-control ${errors.Purpose ? "is-invalid" : ""
                          }`}
                        id="Purpose"
                        aria-describedby="Purpose"
                        name="Purpose"
                        value={formData.Purpose}
                        onChange={handleInputChange}
                      />
                      {errors.Purpose && (
                        <div className="invalid-feedback">{errors.Purpose}</div>
                      )}
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="TargetDate" className="form-label">
                        From Date<span className="required">*</span>
                      </label>
                      <ReactDatePicker
                        autoComplete="off"
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="FromDate"
                        id="FromDate"
                        filterDate={(date) => {
                            const momentDate = moment(date);
                            if (joiningDate && momentDate.isBefore(moment(joiningDate), 'day')) return false;
                            if (relivingDate && momentDate.isAfter(moment(relivingDate), 'day')) return false;
                            return isWeekday(date);
                        }}
                        onChange={(date) => handleDateChange(date, "FromDate")}
                        selected={
                          formData.FromDate
                            ? moment(formData.FromDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        minDate={
                          payrollCalculatedEndDate
                            ? moment(payrollCalculatedEndDate).add(1, 'day').toDate()
                            : moment().subtract(1, 'month').startOf('month').toDate()
                        }
                        maxDate={
                          moment().add(4, "months").endOf("month").year() > moment().year()
                            ? moment().endOf("year").toDate() // ✅ Limit to December 31
                            : moment().add(4, "months").endOf("month").toDate()
                        }
                      />
                    </div>
                    <div className="col-sm-3">
                      <label htmlFor="TargetDate" className="form-label">
                        To Date<span className="required">*</span>
                      </label>

                      <ReactDatePicker
                        autoComplete="off"
                        // minDate={new Date()}
                        changeYear
                        changeMonth
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        format="d-MM-YYYY"
                        name="ToDate"
                        id="ToDate"
                        filterDate={(date) => {
                            const momentDate = moment(date);
                            if (joiningDate && momentDate.isBefore(moment(joiningDate), 'day')) return false;
                            if (relivingDate && momentDate.isAfter(moment(relivingDate), 'day')) return false;
                            return isWeekday(date);
                        }}
                        onChange={(date) => handleDateChange(date, "ToDate")}
                        selected={
                          formData.ToDate
                            ? moment(formData.ToDate, "DD-MMM-YYYY").toDate()
                            : null
                        }
                        dateFormat="dd-MMM-yyyy"
                        minDate={
                          payrollCalculatedEndDate
                            ? moment(payrollCalculatedEndDate).add(1, 'day').toDate()
                            : moment().subtract(1, 'month').startOf('month').toDate()
                        }
                        maxDate={
                          moment().add(4, "months").endOf("month").year() > moment().year()
                            ? moment().endOf("year").toDate() // ✅ Limit to December 31
                            : moment().add(4, "months").endOf("month").toDate()
                        }
                      />
                    </div>
                    <div className="col-sm-12 col-md-2">
                      <div class="mb-3">
                        <label for="days" class="form-label">
                          No. of Days
                        </label>
                        <input
                          type="text"
                          className="form-control text-end"
                          id="days"
                          aria-describedby="days"
                          name="days"
                          value={daysDifference}
                          disabled
                        />
                      </div>
                    </div>
                    <div className="row mt-4">
                      <h6>{`${displayedDates.length} Leave Details`}</h6>
                    </div>
                    <div className="col-md-12">
                      <Table bordered>
                        <thead id="thcolor" className="text-center">
                          <tr>
                            <th className="py-1 px-2">Sr. No.</th>
                            <th className="py-1 px-2">Date</th>
                            <th className="py-1 px-2">Leave Type</th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {displayedDates.map((date, index) => {
                            let leaveType = "LOP";

                            if (remainingCOff > 0) {
                              leaveType = "C-Off";
                              remainingCOff--;
                            } else if (remainingEL > 0) {
                              leaveType = "EL";
                              remainingEL--;
                            }

                            const selectedOption = leaveoptions.find(
                              (option) => option.label === leaveType
                            );

                            return (
                              <tr key={date}>
                                <td className="py-1 px-2">{index + 1}</td>
                                <td className="py-1 px-2">{date}</td>
                                <td className="py-1 px-2">
                                  <Select
                                    value={selectedOption}
                                    options={leaveoptions}
                                    isDisabled={true}
                                    className="compact-select"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="col-md-4">
                        <FileUploader
                          handleFile={handleFile}
                          accept=".pdf,.doc,.docx" // Specify accepted file types
                        />
                      </div>
                      {fileName && (
                        <div className="mt-2">
                          Selected file:{" "}
                          <a
                            href={fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {fileName}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                  </>
                  )}
                  <div className="text-end mt-3">
                    <button type="submit" className="custom-btn" disabled={submitted}>
                      {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-12 col-lg-5 pe-1">
              <LeaveSummary leaveDetails={leaveDetails} />
              <LeaveHistory
                leaveHistory={leaveHistory}
                wfhHistory={wfhHistory}
                onEdit={handleEdit}
                showAction={true}
                title="Leave History"
              />
            </div>
          </div>
        </div>
        <EditWfhModal
          show={showWfhModal}
          onHide={() => {
            setShowWfhModal(false);
            setSelectedWfhGroup(null);
          }}
          groupedRequests={selectedWfhGroup}
          onSuccess={() => {
            fetchMissingPunches();
            fetchLeaveDetails();
          }}
        />
      </>
    );
  }
};

export default ApplyLeave;
